module.exports = __webpack_public_path__ + "Flag-108.6425a017e2fdfd5ee4a09ab5af0cd072.svg";